import Axios from "axios";
import {
    SET_MENU_LIST,
    UNSET_MENU_LIST
  } from "@/store/mutation-types";
import { saveUpdateMenuSetup, getMenuList, deleteMenu  } from "@/store/api";
// initial state
const state = {
  getMenuList: [],
};

const getters = {
  getMenuList(state) {
    return state.getMenuList;
  },
};
const mutations = {
  [SET_MENU_LIST](state, data) {
    state.getMenuList = data;
  },
  [UNSET_MENU_LIST](state) {
    state.getMenuList = [];
  },
  ["SET_MENU_BY_SUBMODULE"](state, data) {
    state.getMenuList = data.map(menu => ({
      ...menu,
      status: 1 // Since these menus are coming from approval API, we assume they are active
    }));
  }
};

const actions = {

  saveUpdateMenuSetup({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateMenuSetup, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getMenuList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getMenuList, data)
        .then(function (response) {
          commit('SET_MENU_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_MENU_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  deleteMenu({ state, commit }, data) {
    commit("SET_LOADING", {color: "warning"});
    return new Promise(function (resolve, reject) {
    Axios.post(deleteMenu, {id:data})
        .then((response) => {
            resolve(response);  
        })
        .catch((error) => {
            reject(error)  
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  }


};

export default {
  state,
  getters,
  actions,
  mutations,
};
